<template>
    <transition name="fading">
        <div v-if="isVisible" class="overlay">
            <div class="modal-card">
              <div class="modal-icon">
                <i class="fas fa-check"></i>
              </div>
              <h3>Confirm changes</h3>
              <p>{{ promptText }}</p>
              <div class="modal-actions">
                <button class="ui-button secondary" @click="handleNo">{{ noText }}</button>
                <button class="ui-button primary" @click="handleYes">{{ yesText }}</button>
              </div>
            </div>
          </div>
    </transition>
  </template>
  
  <script setup>
  import { defineProps, defineEmits } from 'vue';
  
  // Define props
  const props = defineProps({
    isVisible: {
      type: Boolean,
      required: true,
    },
    promptText: {
      type: String,
      required: true,
    },
    yesText: {
      type: String,
      default: 'Yes',
    },
    noText: {
      type: String,
      default: 'No',
    },
  });
  
  // Emit events to parent component
  const emit = defineEmits(['yes', 'no']);
  
  // Handle Yes button click
  const handleYes = () => {
    emit('yes');
  };
  
  // Handle No button click
  const handleNo = () => {
    emit('no');
  };
  </script>
  
  <style scoped>
.overlay {
  position: fixed;
  inset: 0;
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 18px;
  background: rgba(15, 23, 42, 0.38);
  backdrop-filter: blur(8px);
  z-index: 1000;
  cursor: auto;
}

.modal-card {
  width: min(440px, 100%);
  padding: 26px;
  border: 1px solid var(--ui-border, rgba(110, 43, 146, 0.14));
  border-radius: 14px;
  background: #fff;
  box-shadow: 0 24px 80px rgba(15, 23, 42, 0.2);
  text-align: center;
}

.modal-icon {
  width: 44px;
  height: 44px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  margin-bottom: 14px;
  border-radius: 10px;
  background: #f8fafc;
  color: var(--primary-dark);
}

.modal-card h3 {
  margin: 0;
  color: var(--ui-text, #171225);
  font-size: 1.2rem;
  font-weight: 650;
}

.modal-card p {
  margin: 8px 0 0;
  color: var(--ui-muted, #75657f);
  line-height: 1.5;
}

.modal-actions {
  display: flex;
  justify-content: center;
  gap: 10px;
  margin-top: 22px;
}

.fading-enter-active,
.fading-leave-active {
transition: opacity 0.3s
}

.fading-enter-from,
.fading-leave-to {
opacity: 0
}
  </style>
  
